import React, { useState } from 'react';
import { CalendarDaysIcon, FunnelIcon, XMarkIcon } from '@heroicons/react/24/outline';

/* ── shared input style (matches TaskManagementPage) ────────────────────────── */
const dateInputStyle = {
  background: "#2a1755",
  border: "1px solid rgba(139,92,246,0.4)",
  borderRadius: "0.2rem",
  padding: "6px 10px",
  fontSize: "0.8125rem",
  color: "#ddd6fe",
  outline: "none",
  width: 130,
  colorScheme: "dark",
  transition: "border-color 0.15s, box-shadow 0.15s",
};

/* ════════════════════════════════════════════════════════════════════════════ */
const DateSearch = ({ onSearch = () => {}, className = "" }) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if ((startDate && !endDate) || (!startDate && endDate)) {
      setError('Please select both a Start Date and an End Date, or neither to clear the filter.');
      return;
    }

    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      setError('Start Date cannot be after End Date.');
      return;
    }

    onSearch(startDate, endDate, Boolean(startDate && endDate));
  };

  const handleClear = () => {
    setStartDate('');
    setEndDate('');
    setError('');
    onSearch('', '', false);
  };

  return (
    <>
      <style>{`
        .ds-date-input::-webkit-calendar-picker-indicator { filter: invert(0.7) sepia(1) saturate(3) hue-rotate(220deg); cursor: pointer; }
        .ds-date-input:focus { box-shadow: 0 0 0 2px rgba(139,92,246,0.45); border-color: rgba(139,92,246,0.7) !important; }
        .ds-date-input:hover { border-color: rgba(139,92,246,0.65) !important; }
      `}</style>

      <div
        className={`inline-block text-sm ${className}`}
        style={{ padding: 1 }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 5,
            background: "rgba(139,92,246,0.08)",
            border: "1px solid rgba(139,92,246,0.25)",
            borderRadius: "0.875rem",
            padding: "5px 5px",
          }}
        >
          {/* Label */}
          <div style={{ display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
            <FunnelIcon style={{ width: 16, height: 16, color: "#a78bfa" }} />
            <span style={{ fontSize: "0.75rem", fontWeight: 700, color: "#a78bfa", textTransform: "uppercase", letterSpacing: "0.06em" }}>
              Filter by Date Range
            </span>
          </div>

          <form
            onSubmit={handleSubmit}
            style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 10 }}
          >
            {/* Start Date */}
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <label style={{ fontSize: "0.6875rem", fontWeight: 700, color: "#8b7cb3", textTransform: "uppercase", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>
                Start
              </label>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="ds-date-input"
                style={dateInputStyle}
              />
            </div>

            {/* End Date */}
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <label style={{ fontSize: "0.6875rem", fontWeight: 700, color: "#8b7cb3", textTransform: "uppercase", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>
                End
              </label>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="ds-date-input"
                style={dateInputStyle}
              />
            </div>

            {/* Error */}
            {error && (
              <div style={{
                fontSize: "0.6875rem", color: "#f87171",
                background: "rgba(244,63,94,0.12)",
                border: "1px solid rgba(244,63,94,0.25)",
                borderRadius: "0.5rem",
                padding: "4px 10px",
                maxWidth: 240,
              }}>
                {error}
              </div>
            )}

            {/* Buttons */}
            <div style={{ display: "flex", gap: 8 }}>
              <button
                type="submit"
                style={{
                  display: "flex", alignItems: "center", gap: 5,
                  padding: "6px 14px", borderRadius: "0.625rem",
                  background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
                  color: "#fff", fontSize: "0.8125rem", fontWeight: 700,
                  border: "none", cursor: "pointer",
                  transition: "opacity 0.15s",
                }}
                onMouseOver={(e) => e.currentTarget.style.opacity = "0.85"}
                onMouseOut={(e)  => e.currentTarget.style.opacity = "1"}
              >
                <CalendarDaysIcon style={{ width: 14, height: 14 }} />
                Apply
              </button>

              <button
                type="button"
                onClick={handleClear}
                style={{
                  display: "flex", alignItems: "center", gap: 5,
                  padding: "6px 12px", borderRadius: "0.625rem",
                  background: "transparent",
                  color: "#a78bfa", fontSize: "0.8125rem", fontWeight: 600,
                  border: "1px solid rgba(139,92,246,0.35)",
                  cursor: "pointer",
                  transition: "background 0.15s",
                }}
                onMouseOver={(e) => { e.currentTarget.style.background = "rgba(139,92,246,0.15)"; }}
                onMouseOut={(e)  => { e.currentTarget.style.background = "transparent"; }}
              >
                <XMarkIcon style={{ width: 14, height: 14 }} />
                Clear
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default DateSearch;